module.exports = __webpack_public_path__ + "static/media/applepay_1.48067f19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/applepay_1.png
// module id = 1898
// module chunks = 0